var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaireChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#384449",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M295.31,150.12c0,79.56-64.49,144.05-144.05,144.05c-39.94,0-76.07-16.25-102.17-42.5 c-8.65,0.44-44.16,3.88-44.16,3.88s12.79-36.85,14.96-46.23c-8.15-18.06-12.68-38.09-12.68-59.19C7.21,70.56,71.7,6.07,151.26,6.07 S295.31,70.56,295.31,150.12z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FD6E41",
    points: "81.06,156.28 98.99,136.18 134.86,166.48 202.26,97.22 219.57,115.16 133.93,202.65  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireChecked);
export default __webpack_public_path__ + "static/media/questionnaire-checked.2757b59105ebcb8d92588c4a20d13a48.svg";
export { ForwardRef as ReactComponent };